/* ============================================================
   MDBP -- ONE CLICK BUY
   Shared by the five product templates: pack, business plan,
   previsionnel, etude de marche, executive summary.

   Three things this file exists for.

   1. Straight to checkout. Nobody browses this catalogue: one document
      is one purchase. The cart page is a detour.

   2. Exactly one copy, always. These are digital files -- a second copy
      is worth nothing, and a customer who bounces off the checkout and
      clicks again must not end up with two. So we call /cart/update.js
      rather than /cart/add.js: update SETS the quantity, add INCREMENTS
      it. Clicking ten times leaves one in the cart. Anything else the
      customer already had stays untouched.

   3. Nothing happens twice. The first submit locks every buy button on
      the page until the redirect fires.

   Without JavaScript the native form still works: it posts to
   /cart/add with return_to=/checkout, which reaches the checkout too.
   Only the deduplication is lost, and that path is rare enough.
   ============================================================ */
(function () {
  /* Liquid's {% form %} tag takes named arguments, and a hyphenated
     one (data-...) is not safely parseable, so the hook is the class. */
  var SELECTOR = "form.mdbp-form";
  var locked = false;

  function buttons() {
    return document.querySelectorAll(SELECTOR + " button");
  }

  function lock() {
    locked = true;
    var b = buttons();
    for (var i = 0; i < b.length; i++) {
      b[i].disabled = true;
      b[i].setAttribute("aria-busy", "true");
      b[i].classList.add("is-loading");
    }
  }

  function unlock() {
    locked = false;
    var b = buttons();
    for (var i = 0; i < b.length; i++) {
      b[i].disabled = false;
      b[i].removeAttribute("aria-busy");
      b[i].classList.remove("is-loading");
    }
  }

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches(SELECTOR)) return;

    event.preventDefault();
    if (locked) return;

    var field = form.querySelector('input[name="id"]');
    if (!field || !field.value) return;

    lock();

    var updates = {};
    updates[field.value] = 1;

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function () {
        window.location.href = "/checkout";
      })
      .catch(function () {
        /* Network refused or cart rejected: hand the job back to
           Shopify's own form rather than leaving a dead button.
           HTMLFormElement.submit() does not fire the submit event, so
           this cannot loop back into the handler above. */
        unlock();
        form.submit();
      });
  });
})();